import {
  Facebook as FacebookIcon,
  X as XIcon,
  LinkedIn as LinkedInIcon,
  WhatsApp as WhatsAppIcon,
  YouTube as YouTubeIcon,
  Instagram as InstagramIcon,
} from "@mui/icons-material";
import { IconButton } from "@mui/material";

import styles from "./SocialIcon.module.scss";

const SocialShare = ({ socialMediaLinks = {}, wrapperClass }) => {
  const {
    instagram,
    whatsapp,
    youtube,
    linkedin,
    facebook,
    x: X,
  } = socialMediaLinks;

  return (
    socialMediaLinks && (
      <div className={wrapperClass}>
        {instagram && (
          <a href={instagram} target="_block" rel="nofollow">
            <IconButton className={styles.socialButton}>
              <InstagramIcon />
            </IconButton>
          </a>
        )}

        {whatsapp && (
          <a href={whatsapp} target="_block" rel="nofollow">
            <IconButton className={styles.socialButton}>
              <WhatsAppIcon />
            </IconButton>
          </a>
        )}

        {youtube && (
          <a href={youtube} target="_block" rel="nofollow">
            <IconButton className={styles.socialButton}>
              <YouTubeIcon />
            </IconButton>
          </a>
        )}

        {X && (
          <a href={X} target="_block" rel="nofollow">
            <IconButton className={styles.socialButton}>
              <XIcon />
            </IconButton>
          </a>
        )}

        {facebook && (
          <a href={facebook} target="_block" rel="nofollow">
            <IconButton className={styles.socialButton}>
              <FacebookIcon />
            </IconButton>
          </a>
        )}

        {linkedin && (
          <a href={linkedin} target="_block" rel="nofollow">
            <IconButton className={styles.socialButton}>
              <LinkedInIcon />
            </IconButton>
          </a>
        )}
      </div>
    )
  );
};
export default SocialShare;
